import React from 'react';
import { Content } from '../../../types/content';
import { Topic } from '../../../types/topic';
import { VideoThumbnail } from '../../video';
import { ShortsThumbnail } from '../../shorts/ShortsThumbnail';
import AudioThumbnail from '../../audio/AudioThumbnail';
import TopicThumbnail from '../../topics/TopicThumbnail';
import { SearchType } from '../../../types/search';
import { useSearchContext } from '../../../contexts/SearchContext';

interface ResultRendererProps {
  item: Content | Topic;
  thumbnailClass: string;
  thumbnailContentClass: string;
}

const ResultRenderer: React.FC<ResultRendererProps> = ({
  item,
  thumbnailClass,
  thumbnailContentClass
}) => {
  const { contentType } = useSearchContext();

  const renderThumbnail = () => {
    const thumbnailWrapper = (children: React.ReactNode) => (
      <div className={`relative ${thumbnailClass}`}>
        {children}
      </div>
    );

    const thumbnailProps = {
      ...item,
      className: thumbnailContentClass
    };

    switch (contentType) {
      case 'shorts':
        return thumbnailWrapper(
          <ShortsThumbnail {...thumbnailProps as Content} />
        );
      case 'video':
      case 'lives':
        return thumbnailWrapper(
          <VideoThumbnail {...thumbnailProps as Content} />
        );
      case 'audio':
        return thumbnailWrapper(
          <AudioThumbnail {...thumbnailProps as Content} />
        );
      case 'topics':
        return thumbnailWrapper(
          <TopicThumbnail {...thumbnailProps as Topic} />
        );
      default:
        console.warn(`Renderer not implemented for type: ${contentType}`);
        return null;
    }
  };

  return renderThumbnail();
};

export default ResultRenderer; 